import { apiClient } from './client';
import { unwrapAndTransform } from '../utils/api-response';
// ---------------------------------------------------------------------------
// All unwrapping now handled by unwrapAndTransform
// Eliminates: manual response.data.data.mappings/mapping/models patterns
// ---------------------------------------------------------------------------
export const modelTierApi = {
    getModelTierMappings: async () => {
        const response = await apiClient.get('/v1/admin/model-tier-mapping');
        const result = unwrapAndTransform(response);
        return result.mappings;
    },
    updateModelTierMapping: async (tierId, modelId) => {
        const response = await apiClient.put(`/v1/admin/model-tier-mapping/${tierId}`, { modelId });
        const result = unwrapAndTransform(response);
        return result.mapping;
    },
    getSupportedModels: async () => {
        const response = await apiClient.get('/v1/admin/supported-models');
        const result = unwrapAndTransform(response);
        return result.models;
    },
};
